<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
      <Car ref="car" />
      <Apply ref="apply" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import Apply from './apply';
import Car from './car';
import SubBtnBox from 'components/subBtnBox';
import {
  driverArchivesInviteEdit,
  driverArchivesInviteDetail,
} from 'api/archives';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    Apply,
    Car,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/archives/driver/invite/edit',
      formComponents: ['baseForm', 'car', 'apply'],
      editParams: {
        applyId: this.$route.query.id,
        type: this.$route.query.type,
      },
    };
  },
  computed: {
    detailParams () {
      return {
        applyId: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: driverArchivesInviteDetail,
    editApi: driverArchivesInviteEdit,
  },
  async mounted () {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
